import { twMerge } from 'tailwind-merge'
import { InfoIcon } from '@systemeio/ui/icons'

interface SectionMessageProps {
  className?: string
  iconClassName?: string
  textClassName?: string
  Icon?: (props: React.ComponentPropsWithoutRef<'svg'>) => JSX.Element
  style?: 'danger' | 'warn'
}

export const SectionMessage = ({
  children,
  className,
  Icon = InfoIcon,
  iconClassName,
  textClassName,
  style = 'danger',
}: React.PropsWithChildren<SectionMessageProps>) => (
  <div
    className={twMerge(
      `relative flex flex-wrap items-center gap-1 rounded-lg border p-2 [&_a]:underline`,
      style === 'danger' && 'border-danger bg-danger/10',
      style === 'warn' && 'border-yellow bg-yellow/10',
      className,
    )}
  >
    <div className="flex items-center gap-2">
      <Icon
        className={twMerge(
          'shrink-0',
          style === 'danger' && 'fill-danger',
          style === 'warn' && 'fill-yellow',
          iconClassName,
        )}
      />
      <span
        className={twMerge(
          'flex flex-wrap gap-1 text-sm font-normal',
          style === 'danger' && 'text-danger',
          style === 'warn' && 'text-yellow',
          textClassName,
        )}
      >
        {children}
      </span>
    </div>
  </div>
)
